var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h25v7.645H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.546a.749.749 0 0 1-.754-.742c0-.409.338-.741.754-.741s.754.332.754.741a.749.749 0 0 1-.754.742M24.975.537a.737.737 0 0 0-.903-.512l-9.722 2.56a2.237 2.237 0 0 0-1.85-.97c-1.178 0-2.143.904-2.22 2.043L.546 6.22a.723.723 0 0 0-.52.887.735.735 0 0 0 .902.512l9.745-2.566c.403.567 1.071.94 1.827.94 1.165 0 2.122-.884 2.218-2.006l9.736-2.564a.723.723 0 0 0 .52-.887",
    fill: "#DA322A",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.908 20.083a14.57 14.57 0 0 0 2.43 5.954c.392.55 1.179.963 1.832.963h14.66c.652 0 1.44-.414 1.835-.968a14.552 14.552 0 0 0 2.427-5.949H2.908zM23.665 9.266l-.004-.005c-.391-.549-1.179-.963-1.832-.963h-6.593v10.337h11.026c.219-3.261-.646-6.581-2.597-9.369zm-9.902 9.369H2.738a14.623 14.623 0 0 1 2.596-9.369c.395-.554 1.183-.968 1.835-.968h6.594v10.337z",
    fill: "#DA322A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtros);
export default __webpack_public_path__ + "static/media/otros.c85c56fd.svg";
export { ForwardRef as ReactComponent };